import { createEvent } from 'ics';
import PropTypes from 'prop-types';

import Button from 'atoms/button';
import { getHoursAndMinutes } from 'util';

export default function ButtonCalendar({
  startDate,
  startTime,
  duration,
  title,
  location,
}) {
  const durationData = getHoursAndMinutes(duration);

  const downloadIcsFile = () => {
    const start = [...startDate.split('-'), startTime[0], startTime[1]].map(
      (el) => +el,
    );
    const { error, value } = createEvent({
      start,
      title,
      duration: {
        hours: durationData?.hours || 0,
        minutes: durationData?.minutes || 0,
      },
      location,
    });

    if (error) {
      console.log(error);
      return;
    }

    const blob = new Blob([value], { type: 'text/plain;charset=utf-8' });
    const href = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = href;
    link.download = 'event.ics';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  return <Button onClick={downloadIcsFile} text="Add to my calendar" />;
}

ButtonCalendar.propTypes = {
  startDate: PropTypes.string,
  startTime: PropTypes.array,
  duration: PropTypes.number,
  title: PropTypes.string,
  location: PropTypes.string,
};
